<script>
import TaxReturnTableInput from "@/components/accountants/tax_return/table/TaxReturnTableInput.vue";

export default {
  name: "TaxReturnTableRow",
  components: {TaxReturnTableInput},
  props: {
    description: {
      type: String,
      required: true
    },
    calculatedValue: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    }
  }
}
</script>

<template>
  <tr>
    <td scope="row">
      {{ description }}
    </td>

    <td>
      <TaxReturnTableInput :value="value"
                           v-on:input="(v) => $emit('input', v)"
                           :calculated-value="calculatedValue"/>
    </td>

    <td>
      <div class="number">
        <span>€</span>
        <span>{{ (calculatedValue - value) | formatNumber }}</span>
      </div>
    </td>
  </tr>
</template>

<style scoped lang="scss">
.number {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: space-between;
  padding-right: 1rem;
}
</style>